import React from 'react';

import { action, observable } from 'mobx';
import { observer } from 'mobx-react';

import createContext from 'bz-utilities/hooks/context-v2';

export const [BzPopoverStoreContext, useBzPopoverStore] =
  createContext<BzPopoverStore>('BzPopoverStore');

export const BzPopoverStoreProvider: React.FC<React.PropsWithChildren> = observer((props) => {
  const [store] = React.useState(() => new BzPopoverStore());
  return (
    <BzPopoverStoreContext.Provider value={store}>{props.children}</BzPopoverStoreContext.Provider>
  );
});

BzPopoverStoreProvider.displayName = 'BzPopoverStoreProvider';

export abstract class ABzPopoverStore {
  @observable isOpen = false;
  anchorEl?: Element;

  @action
  open(anchorEl: Element): void {
    this._open(anchorEl);
  }

  @action
  close() {
    this._close();
  }

  @action.bound
  protected _open(anchorEl: Element): void {
    this.isOpen = true;
    this.anchorEl = anchorEl;
  }

  @action
  protected _close() {
    this.isOpen = false;
    this.anchorEl = undefined;
  }
}

class BzPopoverStore extends ABzPopoverStore {
  @action.bound
  open(anchorEl: Element): void {
    super.open(anchorEl);
  }

  @action.bound
  close() {
    super.close();
  }
}

export default BzPopoverStore;
